<template>
  <div
    class="w-100"
    style="min-width: 500px">
    <el-dialog
      v-if="innerVisible"
      :close-on-click-modal="true"
      title="Chỉnh sửa chi tiết"
      :visible.sync="innerVisible"
      append-to-body>
      <EditTodo
        :members="members"
        :membersTodo="membersTodo"
        :account-selected="selectedAccount"
        :item="todoItem"
        @closeDialog="innerVisible = false" />
    </el-dialog>
    <div style="margin: -20px -20px 0 -20px; height: 70vh">
      <div
        class="divider-custom-zalo"
        style=""></div>
      <div class="d-flex h-100 mb-2">
        <div
          style="flex: 3; overflow-y: auto; margin-bottom: -20px; border-right: 1px solid #e0e4e8; min-width: 290px"
          class="p-3">
          <div
            class="fw-bolder font-size-16 mb-2 text-break"
            v-bind:style="todoItem.description.length > 0 ? 'color: #1769D7' : 'color:#7589a3'">
            {{ todoItem.description.length > 0 ? todoItem.description : "(Không có tiêu đề)" }}
          </div>
          <div class="text-break">{{ todoItem.content }}</div>
          <div class="divider-custom-zalo mt-2"></div>

          <div class="mt-3">
            <span class="fw-bolder">Trạng thái</span>
            <div class="float-end">
              <span v-html="getStatus(todoItem, selectedAccount.accountId)"></span>
            </div>
          </div>
          <div class="mt-2">
            <span class="fw-bolder mt-2">Thời hạn</span>
            <div
              class="float-end"
              v-bind:class="todoItem.dueDate !== -1 && new Date().getTime() > todoItem.dueDate ? 'zalo-text-danger' : ''">
              {{ getDetailDueDate(todoItem) }}
            </div>
          </div>
          <div class="mt-2">
            <span class="fw-bolder mt-2">Giao cho</span>
            <el-popover
              placement="bottom-start"
              width="250"
              trigger="hover">
              <div
                class="overflow-auto"
                style="max-height: 300px">
                <div
                  v-for="(item, index) in todoItem.assignees"
                  :key="index"
                  class="d-flex mb-2">
                  <el-avatar
                    :src="getAvatar(item)"
                    class="me-2"
                    style="min-width: 20px"
                    :size="20"></el-avatar>
                  <div
                    style="white-space: pre-line; width: 50%"
                    class="pointer-event text-1-line me-1">
                    {{ getName(item) }}
                  </div>
                  <div
                    style="margin-left: auto"
                    class=""
                    v-if="item.status === 0">
                    Đã nhận
                  </div>
                  <div
                    style="margin-left: auto"
                    class="text-done"
                    v-if="item.status === 1">
                    Đã xong
                  </div>
                  <div
                    style="margin-left: auto"
                    class="text-danger"
                    v-if="item.status === -1">
                    Chưa nhận
                  </div>
                </div>
              </div>
              <div
                slot="reference"
                class="pointer float-end d-flex position-relative">
                <div
                  v-for="(item, index) in todoItem.assignees.slice(0, 4)"
                  :key="index">
                  <div v-bind:style="index === 0 ? 'margin-left:0' : 'margin-left:-5px'">
                    <el-avatar
                      :src="getAvatar(item)"
                      :size="20" />
                  </div>
                </div>
                <div
                  v-if="todoItem.assignees.length > 4"
                  style="margin-left: -5px; width: 20px; height: 20px; background-color: #b1b5b9; border-radius: 999px; border: 1px solid whitesmoke"
                  class="d-flex justify-content-center align-items-center">
                  <div class="font-size-12 text-white">+</div>
                </div>
              </div>
            </el-popover>
          </div>
          <div class="fw-bolder my-2 mb-3">Thao tác:</div>
          <div
            style="color: #0a58c0"
            class="font-size-14">
            <div
              @click="acceptTask(todoItem, selectedAccount.accountId)"
              v-if="isShowButtonAcceptTodo()"
              class="d-flex p-2 ps-3 align-items-center border-todo pointer">
              <img
                class="me-2 icon-todo"
                src="/assets/icon/do_icon.svg" />
              <div class="">Đồng ý nhận việc</div>
            </div>
            <div
              @click="finishTask(todoItem, selectedAccount.accountId)"
              v-if="isDone()"
              class="d-flex p-2 ps-3 mt-2 align-items-center border-todo pointer">
              <img
                class="me-2 icon-todo"
                src="/assets/icon/done.svg" />
              <div class="">Hoàn thành công việc</div>
            </div>
            <div
              @click="ding(todoItem, selectedAccount.accountId)"
              v-if="isRemind()"
              class="border-todo ps-3 d-flex mt-2 p-2 align-items-center pointer">
              <img
                class="me-2 icon-todo"
                src="/assets/icon/clock.svg" />
              <div>Nhắc nhở tiến độ</div>
            </div>
            <div
              @click="openEdit()"
              v-if="isEdit() && !members"
              class="border-todo ps-3 d-flex mt-2 p-2 align-items-center pointer">
              <el-image
                class="me-2 icon-todo"
                src="/assets/icon/edit.svg" />
              <div>Chỉnh sửa chi tiết</div>
            </div>
            <div
              v-if="false"
              class="border-todo ps-3 d-flex p-2 mt-2 align-items-center pointer">
              <img
                class="me-2 icon-todo"
                src="/assets/icon/back.svg" />
              <div>Xem tin nhắn gốc</div>
            </div>
            <div
              @click="deleteTask()"
              v-if="isDelete()"
              class="zalo-text-danger border-todo ps-3 d-flex p-2 mt-2 align-items-center pointer">
              <i class="el-icon-delete me-2 font-size-16" />
              <div>Xoá công việc</div>
            </div>
            <div
              @click="rejectTask(todoItem, selectedAccount.accountId)"
              v-if="isShowButtonRejectTodo(todoItem, selectedAccount.accountId)"
              class="zalo-text-danger border-todo ps-3 d-flex p-2 mt-2 align-items-center pointer">
              <img
                class="me-2 icon-todo"
                src="/assets/icon/reject.svg" />
              <div>Từ chối nhận việc</div>
            </div>
          </div>
        </div>
        <div
          style="flex: 8"
          class="  ">
          <div class="p-3 h-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="fw-bolder">Hoạt động</div>
              <el-select
                v-model="value"
                size="mini"
                placeholder="Select">
                <el-option
                  v-for="(item, index) in ['Tất cả', 'Trả lời']"
                  :key="index"
                  :label="item"
                  :value="item"></el-option>
              </el-select>
            </div>
            <div
              ref="scrollContainer"
              v-loading="isLoading"
              class="mb-3"
              style="overflow-x: auto; height: calc(100% - 80px)">
              <div
                v-for="(item, index) in messageListViews"
                :key="index">
                <div class="d-flex mt-2">
                  <el-avatar
                    :size="20"
                    :src="getAvatarHistory(item)"
                    class="me-2" />
                  <div class="flex-1">
                    <div
                      class="rounded-3 p-2"
                      style="display: inline-block"
                      v-bind:style="
                        item.msgType !== 'chat.todo'
                          ? 'min-width:80px; border: 1px solid #C2DCFF;;background: linear-gradient(0deg, #E1EDFD, #E1EDFD);margin-left:0.5rem'
                          : 'margin-top:-0.5rem'
                      ">
                      <div>
                        <span
                          class="fw-bolder"
                          v-if="item.msgType === 'chat.todo'">
                          {{ getNameHistory(item) }}
                        </span>
                        <span
                          class="text-break"
                          v-if="item.msgType === 'chat.todo'"
                          v-html="blendText(item.content)" />
                        <span
                          class="text-break"
                          v-else>
                          <div
                            class="mb-2"
                            style="color: #7a7f83">
                            {{ getNameHistory(item) }}
                          </div>
                          <div>{{ item.content }}</div>
                        </span>
                      </div>
                      <div>
                        <span
                          class="align-middle font-size-12"
                          style="color: #abaebb">
                          {{ formatLastMessageTime(item.ts) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex align-items-center"
              style="margin-bottom: -20px">
              <!--              <el-input placeholder="Nhập tin nhắn cho công việc ... " v-model="newMessage" type="textarea"-->
              <!--                        @keydown.enter.exact.native="sendMessage">-->
              <!--              </el-input>-->
              <el-input
                ref="input"
                type="textarea"
                resize="none"
                placeholder="Nhập tin nhắn cho công việc ... "
                @keydown.enter.exact.native="sendMessage()"
                v-model="newMessage"
                :autosize="{ minRows: 2, maxRows: 5 }" />
              <el-button
                style="border: none"
                class="p-1 pointer rounded-1 pin flex-1 mx-3">
                <img
                  src="/assets/icon/send.svg"
                  class="font-size-20"
                  @click="sendMessage()"
                  alt="" />
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import { COMMON } from "../../lib/Common";
import EditTodo from "./EditTodo";

export default {
  name: "TodoDetail",
  components: { EditTodo },
  props: {
    todoItem: {
      type: Object,
    },
    selectedAccount: {
      type: Object,
    },
    members: {
      type: Array,
    },
  },
  data() {
    return {
      membersTodo: [],
      isLoading: false,
      value: "",
      messageList: [],
      newMessage: "",
      innerVisible: false,
    };
  },
  computed: {
    isDisable() {
      try {
        return this.messageList.findIndex((s) => JSON.parse(s.content).action === "todo.delete") !== -1;
      } catch (e) {
        return false;
      }
    },
    messageListViews() {
      if (this.value !== "Tất cả") {
        return this.messageList.filter((s) => s.msgType === COMMON.WEBCHAT);
      }
      return this.messageList;
    },
  },
  methods: {
    openEdit() {
      this.innerVisible = true;
    },
    blendText(content) {
      let action = JSON.parse(content).action;
      if (action === "todo.delete") {
        return '<span class="pointer mb-0 text-danger">' + " đã xoá công việc " + "</span>";
      }
      let accountId = this.selectedAccount.accountId;
      return "<span>" + this.getContentAction(content, accountId) + "</span>";
    },
    getReplyMsgClientId(extra) {
      try {
        return extra.cliMsgId ? extra.cliMsgId : this.todoItem.message.cliMsgId;
      } catch (e) {
        return new Date().getTime().toString();
      }
    },
    sendMessage() {
      if (this.newMessage.trim().length === 0) return;
      let extra = this.todoItem.extra;
      let req = {
        conversationId: this.createConversationId(),
        toId: this.getToUid(extra),
        accountId: this.selectedAccount.accountId,
        message: this.newMessage,
        ownerId: this.todoItem.creator,
        replyMsgId: extra.msgId,
        replyMsgClientId: this.getReplyMsgClientId(extra),
        replyMsgTs: this.todoItem.createTime.toString(),
        replyMsg: this.todoItem.content,
      };

      let url;
      if (extra.isGroup) {
        url = "/api/message/replyGroupMessage";
      } else {
        url = "/api/message/replyMessage";
      }
      this.$http
        .post(url, req)
        .then((resp) => {
          this.newMessage = "";
          if (resp.data.error_code === 0) {
            this.alert("success", "Đã gửi tin nhắn");
            let message = {};
            message.ts = new Date().getTime().toString();
            message.content = req.message;
            message.msgType = COMMON.WEBCHAT;
            let id = {};
            id.msgIg = new Date().getTime().toString() + "111";
            id.conversationId = this.createConversationId();
            id.idTo = extra.toUid;
            id.uidFrom = "0";
            message.id = id;
            this.messageList.push(message);
            this.scrollToBottom();
          } else if (resp.data.error_code !== 0) {
            this.alert("error", resp.data.error_message);
          }
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra ");
        })
        .finally(() => {
          this.messageText = "";
        });
    },
    getAvatarHistory(item) {
      if (item.msgType === "chat.todo") {
        return this.getAvatar({ userId: JSON.parse(JSON.parse(item.content).params).editor });
      } else {
        let id = item.id.uidFrom != "0" ? item.id.uidFrom : this.selectedAccount.accountId;
        return this.getAvatar({ userId: id });
      }
    },
    getNameHistory(item) {
      if (item.msgType === "chat.todo") {
        return this.getName({ userId: JSON.parse(JSON.parse(item.content).params).editor });
      } else {
        let id = item.id.uidFrom != "0" ? item.id.uidFrom : this.selectedAccount.accountId;
        return this.getName({ userId: id });
      }
    },
    scrollToBottom() {
      this.$nextTick().then(() => {
        let scrollContainer = this.$refs["scrollContainer"];
        if (scrollContainer !== undefined) {
          scrollContainer.scrollTop = scrollContainer.scrollHeight;
        }
      });
    },

    getToUid(extra) {
      let id;
      if (extra.isGroup) {
        id = extra.toUid;
      } else {
        if (this.selectedAccount.accountId === extra.toUid) {
          id = this.todoItem.creator;
        } else {
          id = extra.toUid;
        }
      }
      return id;
    },
    createConversationId() {
      let extra = this.todoItem.extra;
      let group;
      if (extra.isGroup) {
        group = "1";
      } else {
        group = "0";
      }
      let key = this.selectedAccount.accountId + "_" + this.getToUid(extra) + "_" + group + "_" + "0";
      return key;
    },
    async fetchMessageList() {
      this.isLoading = true;
      await this.$http
        .post("/api/message/filter", {
          accountId: this.selectedAccount.accountId,
          conversationId: this.createConversationId(),
          timestamp: "",
          pageSize: 1000,
        })
        .then((resp) => {
          if (resp.data.length > 0) {
            this.messageList = resp.data
              .reverse()
              .filter(
                (s) =>
                  (s.quoteMsg && JSON.parse(s.quoteMsg).globalMsgId == this.todoItem.extra.msgId) ||
                  (s.msgType === "chat.todo" &&
                    ["todo.delete", "todo.ding", "todo.update"].includes(JSON.parse(s.content).action) &&
                    JSON.parse(JSON.parse(s.content).params).item.id === this.todoItem.id)
              )
              .sort((a, b) => Number(a.ts) - Number(b.ts));
          }
          this.scrollToBottom();
        })
        .finally(() => (this.isLoading = false));
    },
    isDelete() {
      return this.isCreator(this.todoItem);
    },
    isEdit() {
      return this.isCreator(this.todoItem) && this.todoItem.status !== 1;
    },
    isDone() {
      let item = this.todoItem.assignees.find((s) => s.userId === this.selectedAccount.accountId && s.status === 1);
      return !item && this.todoItem.status !== 1;
    },
    isRemind() {
      return this.isCreator(this.todoItem) && this.todoItem.status !== 1;
    },

    // isShowButtonRejectTodo() {
    //   return !this.isCreator() && this.todoItem.status === -1 && this.todoItem.assignees.find(s => [-1, 0].includes(s.status) && s.userId === this.selectedAccount.accountId);
    // },
    isShowButtonAcceptTodo() {
      return (
        !this.isCreator(this.todoItem) &&
        this.todoItem.status === -1 &&
        this.todoItem.assignees.find((s) => s.status === -1 && s.userId === this.selectedAccount.accountId)
      );
    },
    isGroup() {
      try {
        return this.todoItem.extra.isGroup;
      } catch (e) {
        return true;
      }
    },
    deleteTask() {
      let req = {
        accountId: this.selectedAccount.accountId,
        params: this.todoItem.id,
      };
      this.$confirm("Công việc này sẽ không còn hiển thị trên danh sách của bạn. Bạn có chắc rằng bạn muốn xoá công việc này không?", "Cảnh báo", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      }).then(async () => {
        this.$http.post("/api/todo/removeTask", req).then((s) => {
          if (s.data.error_code === 0) {
            this.app.isShowTodoDetail = false;
            this.alert("success", "Thao tác thành công");
            this.todoItem.action = "delete";
            this.$bus.$emit("updateTask", this.todoItem);
          } else {
            return this.alertError(s.data.error_message);
          }
        });
      });
    },
    getName(item) {
      if (item.userId === this.selectedAccount.accountId) {
        return this.app.accounts.find((s) => s.accountId === this.selectedAccount.accountId).displayName;
      }
      if (this.members) {
        let data = this.members.find((s) => s.id === item.userId);
        if (data) {
          return data.name;
        } else {
          return "";
        }
      }

      let data = this.app.listContactsAccount.find((s) => s.uid === item.userId);
      if (data) {
        if (data.displayName && data.displayName.length > 0) {
          return data.displayName;
        }
        return data.zaloName;
      } else {
        let names;
        names = this.app.aliases.find((s) => s.id === item.userId && s.accountId === this.selectedAccount.accountId);
        if (names) {
          return names.name;
        }

        return "";
      }
    },
    getAvatar(item) {
      if (item.userId === this.selectedAccount.accountId) {
        return this.app.accounts.find((s) => s.accountId === this.selectedAccount.accountId).avatar;
      }

      if (this.members) {
        let data = this.members.find((s) => s.id === item.userId);
        if (data) {
          return data.avatar;
        } else {
          let index = this.todoItem.assignees.findIndex((s) => item.userId === s.userId);
          if (index !== -1) {
            this.todoItem.assignees.splice(index, 1);
          }
          return "";
        }
      }
      let data = this.app.listContactsAccount.find((s) => s.uid === item.userId);
      if (data) {
        return data.avatar;
      } else {
        let names;
        names = this.app.aliases.find((s) => s.id === item.userId && s.accountId === this.selectedAccount.accountId);
        if (names) {
          return names.avatar;
        }
        return "";
      }
    },
    async getGroupInfo(id) {
      this.$http
        .get("/api/message/groupInfoV2", {
          params: {
            accountId: this.selectedAccount.accountId,
            groupId: id,
          },
        })
        .then(async (resp) => {
          let gridInfoMap = resp.data.data?.gridInfoMap[id];
          gridInfoMap.memberVerMap = {};
          gridInfoMap.memVerList.forEach((i) => {
            let parts = i.split("_");
            gridInfoMap.memberVerMap[parts[0]] = parts[1];
          });
          let memberMap;
          if (gridInfoMap !== undefined) {
            memberMap = gridInfoMap.memberVerMap;
          } else {
            return (this.membersTodo = []);
          }
          let newMemberMap = {};
          if (memberMap === {} || memberMap === null) return;
          for (const key of Object.keys(memberMap)) {
            let item = this.app.aliases.find((s) => s.id == key && this.selectedAccount.accountId == s.accountId);
            if (item) {
              this.membersTodo.push(item);
            } else {
              newMemberMap[key] = memberMap[key];
            }
          }

          if (Object.keys(newMemberMap).length > 498) {
            const chunkSize = 498;
            for (let i = 0; i < Object.keys(newMemberMap).length; i += chunkSize) {
              let data = Object.fromEntries(Object.entries(newMemberMap).slice(i, i + chunkSize));
              this.getMembers(data);
            }
          } else {
            this.getMembers(newMemberMap);
          }
        });
    },
    getMembers(memberMap) {
      if (Object.keys(memberMap).length === 0) return;
      let request = {
        memberMap: memberMap,
        accountId: this.selectedAccount.accountId,
      };

      this.$http.post("/api/conversation/groupMember", request).then((resp) => {
        if (resp.data && resp.data.length > 0) {
          this.membersTodo.push(...resp.data);
          resp.data.forEach((s) => {
            if (!this.app.aliases.find((a) => a.accountId === this.selectedAccount.accountId && s.id === a.id)) {
              this.app.aliases.push(s);
            }
          });
        }
      });
    },
    getDetailDueDate(item) {
      let date = item.dueDate;
      if (item.dueDate === -1) {
        return "Không thời hạn";
      }
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
  mounted() {
    this.value = "Tất cả";
    this.fetchMessageList();
    if (this.todoItem.extra.isGroup && !this.members) {
      this.getGroupInfo(this.getToUid(this.todoItem.extra));
    }
    this.$refs.input.focus();
  },
};
</script>

<style scoped>
.border-todo {
  border: 1px solid #e0e4e8;
  border-radius: 0.5rem;
  line-height: 30px;
}

.icon-todo {
  width: 16px;
  height: 16px;
}

.border-todo:hover {
  background-color: #eff2f7;
}
</style>